import React, { Component } from 'react';
import Footer from "../Components/footer";
import { fetchSignApplication } from "./BasicProfile/api";

class Complete extends Component {
    state = {
        isJointAccount: false,
        jointHolder2: "",
        jointHolder3: ""
    };

    async componentDidMount() {
        try {
            const res = await fetchSignApplication();
            if (res?.data?.fetch_signup_application) {
                const app = res.data.fetch_signup_application;
                this.setState({
                    isJointAccount: app.is_joint_account,
                    jointHolder2: app.joint_holder_second_fullname,
                    jointHolder3: app.joint_holder_third_fullname,
                });
            }
        } catch (e) {
            console.error("Error fetching signup application on complete page:", e);
        }
    }

    render() {
        return (      <div className="col-md-6 col-lg-5 col-xl-4">

          <div className="container my-auto py-4 bg-white shadow-lg rounded">
                <div className="row mt-2">
                  <div className="col-11 col-lg-11 mx-auto">
                    <h1>Complete!</h1>
                    <div className="text-muted text-2 text-left">
                      <p>Your TRDR sign up process is complete.</p>
                      
                      {this.state.isJointAccount && (
                        <div className="alert alert-warning text-left mb-3" style={{ fontSize: "13px", borderRadius: "8px", color: "#856404", backgroundColor: "#fff3cd", borderColor: "#ffeeba" }}>
                          <h6 style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px" }}>Note for Joint Account:</h6>
                          <p className="mb-1">The other joint holder(s) will receive an SMS and email with a link to complete their Aadhaar e-signature:</p>
                          <ul className="pl-3 mb-0" style={{ listStyleType: "circle" }}>
                            {this.state.jointHolder2 && <li><strong>Second Holder:</strong> {this.state.jointHolder2}</li>}
                            {this.state.jointHolder3 && <li><strong>Third Holder:</strong> {this.state.jointHolder3}</li>}
                          </ul>
                          <p className="mt-2 mb-0" style={{ fontSize: "12px", fontStyle: "italic" }}>The account will be activated once all joint holders have successfully signed.</p>
                        </div>
                      )}

                      <p className="alert alert-success alert-dismissible fade show text-left">Within the next 24-48 hrs, we will update you about your demat + trading account along with the TRDR app login details</p>  
                   
                    </div>
                  </div>
                </div>
              </div><Footer /></div>
              )
    }
}
export default Complete;